import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { getSingleAppliedSavingsPolicy } from "../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import {
  makeSavingsPayment,
  resetTransactionStatus,
  reverseSavingsTransaction,
  // reverseTransaction,
} from "../../../redux/slice/transaction/transactionSlice";

const PaySavingsPremium = ({
  customer_id,
  policy_id,
  policy_app_no,
  editing,
  setEditing,
  transactionDetails,
  setTransactionDetails,
  life_cover_id,
}) => {
  const close = useRef();

  const { state } = useLocation();

  const { user, user_permissions } = useSelector((state) => state.auth?.user);
  const { isSuccess } = useSelector((state) => state.transaction);
  const { customer_policy_details } = useSelector(
    (state) => state.savingsPolicy
  );

  const [reversePayment, setReversePayment] = useState();

  const today = new Date().toISOString().split("T")[0];

  const dispatch = useDispatch();

  const onSubmit = (values, { resetForm }) => {
    dispatch(makeSavingsPayment(values));
  };

  const validationScehma = Yup.object().shape({
    payment_date: Yup.string("Payment Date must be a string").required(
      "Date cannot be blank"
    ),
    amount: Yup.number().required("Amount cannot be blank"),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      payment_date: editing ? transactionDetails?.payment_date : "",
      desc:
        editing && transactionDetails?.desc !== null
          ? transactionDetails?.desc
          : "",
      amount: editing ? transactionDetails?.part_premium : "",
      policy_id: customer_policy_details?.policy_app_details?.policy_id,
      policy_app_no:
        customer_policy_details?.policy_app_details?.policyAppNumber,
      effective_date:
        customer_policy_details?.policy_app_details?.effectiveDate,
      staff_id: user?.staff_id,
      customer_id: customer_policy_details?.policy_app_details?.customerId,
      life_cover_id: customer_policy_details?.life_cover?.life_cover_id,
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        getSingleAppliedSavingsPolicy({
          customer_id: state?.customerId,
          policy_number: state?.policyAppNumber,
        })
      );
      const closeBtn = document.getElementById("closeButton");
      closeBtn.click();
      setTransactionDetails && setTransactionDetails(null);
      dispatch(resetTransactionStatus());
    }
  }, [
    dispatch,
    isSuccess,
    resetForm,
    setTransactionDetails,
    state?.customerId,
    state?.policyAppNumber,
  ]);

  useEffect(() => {
    setReversePayment(
      user_permissions?.some(
        (permission) => permission.name === "Reverse payment"
      )
    );
  }, [user_permissions]);

  return (
    <div>
      <div className='modal-header'>
        <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
          Pay Premium
        </h4>
        <span
          type='button'
          className=' bg-gray hover rounded-circle border-none'
          data-bs-dismiss='modal'
          aria-hidden='true'
          ref={close}
          onClick={() => {
            resetForm();
            setEditing && setEditing(false);
            setTransactionDetails && setTransactionDetails(null);
          }}
          style={{ padding: "0px 3px" }}
        >
          <i
            className='mdi mdi-close text-white'
            style={{ fontSize: "16px" }}
          ></i>
        </span>
      </div>
      <div className='modal-body'>
        <form onSubmit={handleSubmit}>
          <div className='row mb-3'>
            <div className='col-md-12 sm-text-end'>
              <label htmlFor='amount' className={`form-label mt-1`}>
                Amount<span className='text-danger'>*</span>
              </label>
            </div>
            <div className='col-md-12'>
              <input
                type='number'
                name='amount'
                className='form-control form-control-sm'
                id='amount'
                value={values?.amount}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={editing}
              />
              {errors?.amount && touched?.amount && (
                <p className='text-danger mb-0'>{errors?.amount}</p>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-sm-12'>
              <label for='status_date' className='col-form-label'>
                Date<span className='text-danger'>*</span>
              </label>
            </div>
            <div class='col-sm-12'>
              <input
                type='date'
                name='payment_date'
                max={today}
                className='form-control form-control-sm'
                id='payment_date'
                value={values?.payment_date}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={editing}
              />
              {errors?.payment_date && touched?.payment_date && (
                <p className='mb-0 text-danger'>{errors?.payment_date + "*"}</p>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-12 sm-text-end'>
              <label for='last_name' className='col-form-label'>
                Description
              </label>
            </div>
            <div className='col-sm-12'>
              <textarea
                disabled={editing}
                name='desc'
                className='form-control form-control-sm'
                id='desc'
                value={values?.desc}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
          <div className='d-flex justify-content-end gap-3'>
            <button
              type='button'
              ref={close}
              id='closeButton'
              className='btn btn-sm mt-2 px-3 text-muted'
              data-bs-dismiss='modal'
              style={{ background: "#F1F0F1" }}
              onClick={() => {
                resetForm();
                setEditing && setEditing(false);
                setTransactionDetails && setTransactionDetails(null);
              }}
            >
              Cancel
            </button>
            {!editing && (
              <button
                type='submit'
                className='btn btn-primary btn-sm mt-2 px-3'
                data-bs-dismiss='modal'
              >
                Make Payment
              </button>
            )}
            {editing &&
              reversePayment &&
              transactionDetails?.transaction_type !== "credit reversed" &&
              transactionDetails?.transaction_type !== "claim processed" &&
              transactionDetails?.transaction_type !== "Savings Deposit Reversed" &&
              transactionDetails?.transaction_type !== "\t\n\t\t\t\t\t\tLife cover charge Reversed" &&
              transactionDetails?.transaction_type !== "\t\n\t\t\t\tLife cover charge Reversed" &&
              transactionDetails?.desc !== "interest posted" &&
              transactionDetails?.complete_payment && (
                <button
                  type='button'
                  className='btn btn-danger btn-sm mt-2 px-3 text-white'
                  onClick={() =>
                    dispatch(
                      reverseSavingsTransaction({
                        transaction_id: transactionDetails?.transaction_id,
                        staff_id: user?.staff_id,
                        customer_id: transactionDetails?.customer_id,
                        policy_app_no: transactionDetails?.policy_app_no,
                      })
                    )
                  }
                >
                  Reverse
                </button>
              )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaySavingsPremium;
